<meeting-scheduler-duration-multi-select
  [options]="options"
  [duration]="bufferDurationBeforeMeeting"
  [title]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION_BEFORE.TITLE' | translate"
  [description]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION_BEFORE.DESCRIPTION' | translate"
  [hint]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.HINT' | translate"
  (durationSelected)="onDurationSelected($event)"
></meeting-scheduler-duration-multi-select>
